module.exports = __webpack_public_path__ + "img/banner-c02f85e2.png";